const mergeArticulosSelected = ({
  articulosSelected,
  articulos: articulosByCategoria,
}: $TSMigrationFixMe) => {
  const newArticulosSelected = { ...articulosSelected }

  Object.keys(articulosByCategoria).forEach((categoriaName) => {
    const articulosItems = articulosByCategoria[categoriaName]?.articulos || []
    const articulosSelectedItems =
      articulosSelected[categoriaName]?.articulos || []

    const seenSelectedIds = new Set(
      articulosSelectedItems?.map((art: $TSMigrationFixMe) => art.id)
    )

    const articulosIdToUnselect = new Set(
      articulosItems
        .filter((currArticulo: $TSMigrationFixMe) => !currArticulo.isSelected)
        .map((art: $TSMigrationFixMe) => art.id)
    )

    const articulosToSelect = articulosItems.filter(
      (currArticulo: $TSMigrationFixMe) =>
        currArticulo.isSelected && !seenSelectedIds.has(currArticulo.id)
    )

    const mergedArticulosSelected = [
      ...articulosSelectedItems,
      ...articulosToSelect,
    ].filter((art) => !articulosIdToUnselect.has(art.id))

    if (mergedArticulosSelected.length) {
      newArticulosSelected[categoriaName] = {
        ...articulosByCategoria[categoriaName],
        articulos: mergedArticulosSelected,
      }
    } else {
      delete newArticulosSelected[categoriaName]
    }
  })

  return newArticulosSelected
}

export default mergeArticulosSelected
